import React from 'react'
import {connect} from 'react-redux'
import {fileAdd, fileSuccess, fileUpdate, urlError,} from "../../actions/FileActions";
import axios from 'axios';
import FileEntity, {createUid} from "../../helpers/FileEntity";
import Uploader from "./Uploader";
import PropTypes from "prop-types";
import {FILE_TYPE_LINK} from "../../constants/FileTypeConstant";
import SlackService from "../../../../../common/services/SlackService";

class UrlUploader extends Uploader {

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {formUrls} = this.props;

        if (prevProps.formUrls !== formUrls && formUrls.length) {
            this.handleUrls(formUrls);
        }
    }

    info = (fileEntity, url) => {
        return axios.get('/api/file/media-info?url=' + url).then(res => {
            return res.data;
        }).catch(error => {
            this.props.urlError(fileEntity, error);
        });
    };

    finishCallback = (urls, url) => {
        if (urls[urls.length - 1] === url) {
            this.props.finishCallback();
        }
    };

    handleUrls = (urls) => {
        urls.map(url => {
            if (!url) {
                return;
            }

            const fileEntity = new FileEntity({
                uid: createUid(),
                originalName: url,
                source: url,
            });

            this.props.fileAdd(fileEntity);

            this.getMediaInfo(fileEntity, url).then(data => {
                fileEntity.originalName = data.originalName;
                fileEntity.size = data.size;
                fileEntity.mime = data.mime;
                fileEntity.extension = data.extension;
                fileEntity.duration = data.duration;
                console.log(this.props.dependencies);
                return this.validate(this.props.fileItems, fileEntity, this.props.dependencies);
            }).then(() => {
                return this.save(fileEntity, FILE_TYPE_LINK);
            }).then(data => {
                fileEntity.name = data.path;
                this.props.fileSuccess(fileEntity);
                this.props.fileUploadedCallback(fileEntity);
                this.finishCallback(urls, url)
            }).catch(error => {
                this.props.urlError(fileEntity, error);
                this.finishCallback(urls, url);
                SlackService.send(`client can't add url :cinema: ${url.replace(/(^\w+:|^)\/\//, '')}`);
            });
        });
    };

    render() {
        return null;
    }
}

UrlUploader.propTypes = {
    fileUploadedCallback: PropTypes.func,
    finishCallback: PropTypes.func,
};

UrlUploader.defaultProps = {
    fileUploadedCallback: () => {},
    finishCallback: () => {},
};

export default connect(
    state => ({
        formUrls: state.fileForm.urls,
        fileItems: state.file.files,
        dependencies: state.dictionary.dependencies,
    }),
    dispatch => ({
        fileAdd: (fileEntity) => dispatch(fileAdd(fileEntity)),
        fileUpdate: (fileEntity) => dispatch(fileUpdate(fileEntity)),
        fileSuccess: (fileEntity) => dispatch(fileSuccess(fileEntity)),
        urlError: (fileEntity, message) => dispatch(urlError(fileEntity, message)),
    })
)(UrlUploader);